"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _config = _interopRequireDefault(require("../config"));
var _default = exports.default = function _default() {
  var code = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return function () {
    window.location.href = "".concat(_config.default.nui.baseUrl, "/nui-auth/api/signout").concat(code === '' ? '' : '?signedout=' + code);
  };
};